import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('benchory_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('benchory_token');
      localStorage.removeItem('benchory_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authApi = {
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
};

export const sectorsApi = {
  list: () => api.get('/sectors'),
  create: (data) => api.post('/sectors', data),
  update: (id, data) => api.put(`/sectors/${id}`, data),
  delete: (id) => api.delete(`/sectors/${id}`),
};

export const establishmentsApi = {
  list: () => api.get('/establishments'),
  get: (id) => api.get(`/establishments/${id}`),
  create: (data) => api.post('/establishments', data),
  update: (id, data) => api.put(`/establishments/${id}`, data),
  delete: (id) => api.delete(`/establishments/${id}`),
};

export const dataApi = {
  list: (estId) => api.get(`/data/${estId}`),
  submit: (estId, data) => api.post(`/data/${estId}`, data),
};

export const reportsApi = {
  list: () => api.get('/reports'),
  get: (id) => api.get(`/reports/${id}`),
  generate: (data) => api.post('/reports/generate', data),
  generateAll: (data) => api.post('/reports/generate-all', data),
  downloadPdf: (id) => api.get(`/reports/${id}/pdf`, { responseType: 'blob' }),
  publish: (id) => api.patch(`/reports/${id}/publish`),
  unpublish: (id) => api.patch(`/reports/${id}/unpublish`),
  pendingData: () => api.get('/reports/pending-data'),
};

export const historicalApi = {
  get: (estId) => api.get(`/historical/${estId}`),
};

export const dashboardApi = {
  stats: () => api.get('/dashboard/stats'),
};

export const clientApi = {
  scoreTrend: () => api.get('/client/score-trend'),
  alerts: () => api.get('/client/alerts'),
  establishment: () => api.get('/client/establishment'),
  updateEstablishment: (data) => api.put('/client/establishment', data),
  reports: () => api.get('/client/reports'),
  report: (id) => api.get(`/client/reports/${id}`),
};

export const contactApi = {
  submit: (data) => api.post('/contact', data),
};

export const adminApi = {
  analytics: () => api.get('/admin/analytics'),
  analyticsBi: (sectorSlug) => api.get('/admin/analytics-bi', { params: { sector_slug: sectorSlug || '' } }),
  alerts: () => api.get('/admin/alerts'),
  contacts: () => api.get('/admin/contacts'),
  markContactTreated: (id) => api.put(`/admin/contacts/${id}/status`),
  pendingClients: () => api.get('/admin/pending-clients'),
  approveClient: (id, data) => api.post(`/admin/approve-client/${id}`, data),
  rejectClient: (id) => api.post(`/admin/reject-client/${id}`),
  clientAccounts: () => api.get('/clients/accounts'),
  deleteClientAccount: (userId) => api.delete(`/clients/accounts/${userId}`),
  purgeAll: () => api.post('/admin/purge'),
  importData: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/admin/import-data', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  kpis: (params) => api.get('/admin/kpis', { params }),
  createKpi: (data) => api.post('/admin/kpis', data),
  updateKpi: (kpiId, data, params) => api.put(`/admin/kpis/${kpiId}`, data, { params }),
  deleteKpi: (kpiId, params) => api.delete(`/admin/kpis/${kpiId}`, { params }),
  toggleKpi: (kpiId, params) => api.patch(`/admin/kpis/${kpiId}/toggle`, null, { params }),
};

export const seedApi = {
  seed: () => api.post('/seed'),
};

export const campaignsApi = {
  list: () => api.get('/campaigns'),
  get: (id) => api.get(`/campaigns/${id}`),
  adminList: () => api.get('/admin/campaigns'),
  adminCreate: (data) => api.post('/admin/campaigns', data),
  adminUpdate: (id, data) => api.put(`/admin/campaigns/${id}`, data),
  adminDelete: (id) => api.delete(`/admin/campaigns/${id}`),
  adminSeed: () => api.post('/admin/campaigns/seed'),
};

export default api;
